namespace Portico.Models {
    export class SessionDetailResponse {
        public success: boolean;
        public messages: string[];
        public sessionDetail: SessionDetail;
    }
}